module.exports = __webpack_public_path__ + "static/media/student-summary-score.8d8f578c.png";